export default __webpack_public_path__ + "static/media/waffle10.c7dc4c5b.jpg";